import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { clearAccordionTable } from '../../../core/table-accordion/redux/actions';
import NpvrComponent from './NpvrComponent';
import { clearCachedNpvr, fetch, getAssociatedDevices } from './redux/actions';

const mapStateToProps = (state: ApplicationState) => ({
  npvr: state.npvr,
})

export default connect(mapStateToProps, {
  fetch,
  clearAccordionTable,
  clearCachedNpvr,
  getAssociatedDevices,
})(NpvrComponent)
